const BASE_DATE = `1900-01-01 00:00:00`
const MILLIS_IN_MINUTE = 1000
const SECONDS_MINUTES = 60
const ZERO_PREFIX = '0'

const printValue = (value: number) => {
  const strValue = String(value)
  if (strValue.length !== 1) return value
  return `${ZERO_PREFIX}${value}`
}

export const getDateWithoutTimeZone = (date: Date | string): Date => {
  return new Date(new Date(date).toISOString().slice(0, -1))
}

const getTimePeriodFromDate = (duration: Date | string): string => {
  if (!duration) {
    return '0:0:0'
  }

  const milliseconds = +getDateWithoutTimeZone(duration) - +new Date(BASE_DATE)
  const totalSeconds = milliseconds / MILLIS_IN_MINUTE

  const totalMinutes = Math.floor(totalSeconds / SECONDS_MINUTES)
  const hours = Math.floor(totalMinutes / SECONDS_MINUTES)
  const minutes = totalMinutes % SECONDS_MINUTES
  const seconds = totalSeconds % SECONDS_MINUTES

  return `${printValue(hours)}:${printValue(minutes)}:${printValue(seconds)}`
}

export { getTimePeriodFromDate }
